<template>
  <div class="admin-container py-5">

    <div class="row g-4 d-flex align-items-stretch">

      <!-- PERSONNELS -->
      <div class="col-12 d-flex">
        <div class="admin-card flex-fill">
          <div class="staff-block">
            <h2 class="block-title">Personnel Administratif</h2>

            <div class="row g-4">

                <div class="col-12 col-md-4" @click="openModal('/Soeur AHOLOU Marcelle.JPG')">
                  <div class="staff-item">
                    <img 
                      src="/Soeur AHOLOU Marcelle.JPG" 
                      class="staff-photo"
                      @click="openModal('/Soeur AHOLOU Marcelle.JPG')"
                    />
                    <p class="staff-name">Sr Marcelle Aholou</p>
                    <p class="role">Assistante de direction</p>
                  </div>
                </div>

                <div class="col-12 col-md-4" @click="openModal('/ADIHO Josith.jpg')">
                  <div class="staff-item">
                    <img src="/ADIHO Josith.jpg" class="staff-photo" @click="openModal('/ADIHO Josith.jpg')" />
                    <p class="staff-name">Josith Adiho</p>
                    <p class="role">Secrétaire académique & Comptabilité</p>
                  </div>
                </div>

                <div class="col-12 col-md-4" @click="openModal('/da SILVA Péroline .jpg')">
                  <div class="staff-item">
                    <img src="/da SILVA Péroline .jpg" class="staff-photo" @click="openModal('/da SILVA Péroline .jpg')" />
                    <p class="staff-name">da Silva Péroline</p>
                    <p class="role">Assistante au Secrétariat</p>
                  </div>
                </div>

              </div>
          </div>
        </div>
      </div>

      <!-- HORAIRES -->
      <div class="col-12 col-md-6 d-flex">
        <div class="admin-card flex-fill">
          <div class="schedule-block">
            <h2 class="block-title">Accueil & Secrétariat</h2>

            <div class="schedule">
              <p><strong>Lundi, Mardi, Jeudi, Vendredi :</strong> 9h – 13h & 15h30 – 20h30</p>
              <p><strong>Mercredi :</strong> 16h – 20h30</p>
              <p><strong>Samedi :</strong> 8h30 – 13h</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 d-flex">
        <div class="admin-card flex-fill">
          <div class="schedule-block">
            <h2 class="block-title">Informations bancaires</h2>

            <div class="schedule">
              <p><strong>Banque UBA</strong>n° 501100007916 </p>
              <p><strong>Iban :</strong>BJ0670150150110000791654. </p>
              <p><strong>Code SWIFT/BIC  :</strong> COBBBJBJ</p>
              <p><strong>Titulaire : </strong>ECOLE D’INITIATION THEOLOGIQUE ET PASTORALE.</p>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
  <!-- MODALE IMAGE -->
  <div v-if="isModalOpen" class="image-modal" @click.self="closeModal">
    <div class="modal-content">
      <span class="close-btn" @click="closeModal">&times;</span>
      <img :src="selectedImage" class="modal-image" />
    </div>
  </div>

</template>
<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "AdminSection",
  setup() {
    const isModalOpen = ref(false);
    const selectedImage = ref("");

    const openModal = (image: string) => {
      selectedImage.value = image;
      isModalOpen.value = true;
    };

    const closeModal = () => {
      isModalOpen.value = false;
      selectedImage.value = "";
    };

    return {
      isModalOpen,
      selectedImage,
      openModal,
      closeModal,
    };
  },
});
</script>


<style scoped>
.admin-container {
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
}

.admin-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
  padding: 30px 35px;
  border-left: 10px solid #ffc107;
  transition: 0.3s;
}

.admin-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0,0,0,0.15);
}

.block-title {
  font-size: 1.4rem;
  font-weight: 800;
  color: #0b1b3f;
  margin-bottom: 15px;
  text-align: center;
}

.staff-list {
  list-style: none;
  padding: 0;
}

.staff-list li {
  margin-bottom: 10px;
  font-size: 1.05rem;
  font-weight: 600;
  color: #0b1b3f;
}

.role {
  color: #ffc107;
  font-weight: 800;
}

.schedule p {
  background: #f8f9fa;
  padding: 12px 15px;
  border-radius: 10px;
  margin-bottom: 10px;
  border-left: 4px solid #0b1b3f;
  font-weight: 600;
}

@media (max-width: 768px) {
  .admin-card {
    padding: 25px;
  }
}

.staff-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.staff-item {
  text-align: center;
  background: #f8f9fa;
  padding: 25px 20px;
  border-radius: 15px;
  transition: 0.3s;
  height: 100%;
}

.staff-item:hover {
  transform: translateY(-6px);
  background: #fff8e1;
}


.staff-photo {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 5px solid #ffc107;
  margin-bottom: 15px;
}


.staff-name {
  font-weight: 800;
  color: #0b1b3f;
  margin: 5px 0 0 0;
  font-size: 1.07rem;
}

.role {
  font-size: 0.95rem;
  color: #ffc107;
  font-weight: 700;
  margin-bottom: 8px;
}

.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 95vw;
  max-height: 95vh;
}

.modal-image {
  max-width: 90vw;
  max-height: 90vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.6);
}

.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 30px;
  background: white;
  color: black;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
}

</style>
